import React, { useContext, useEffect, useState } from "react";
import BarCompare from "../../comparisoncharts/BarCompare";
import LineCompare from "../../comparisoncharts/LineCompare";
import PieCompare from "../../comparisoncharts/PieCompare";
import GaugeCompare from "../../comparisoncharts/GaugeCompare";
import Loader from "../Loader/Loader";
import { StoreContext } from "../../store/Store";
import { decrypt } from "../../Utils/Encryption";
import { useParams } from "react-router-dom";

const ComparisonChildChartComponent = () => {
  const { getChildComparison, childComparisonMetrics, loading } =
    useContext(StoreContext);

  const [breadcrumps, setBreadcrumps] = useState([]);
  const { metricname, metricid } = useParams();
  const decodedMetricId = decrypt(metricid);
  const status = 1;

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getChildComparison(configid, decodedMetricId);
  }, [metricid]);

  useEffect(() => {
    setBreadcrumps((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.metric_id === metricid
      );

      if (existingIndex !== -1) {
        return prev.slice(0, existingIndex + 1);
      } else {
        return [
          ...prev,
          {
            metric_id: metricid,
            metric_name: metricname,
          },
        ];
      }
    });
  }, [metricid, metricname]);

  const renderChart = (chartType, metricData, i) => {
    switch (chartType) {
      case "Bar Chart":
        return <BarCompare key={i} metricData={metricData} />;
      case "Gauge Chart":
        return <GaugeCompare key={i} metricData={metricData} />;
      case "Pie Chart":
        return <PieCompare key={i} metricData={metricData} />;
      case "Line Chart":
        return <LineCompare key={i} metricData={metricData} />;
      default:
        return <p key={i}>No chart type found for {chartType}</p>;
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div className="dashboard" style={{ minHeight: "80.5vh" }}>
      <div
        className={`breadcrumps d-flex ${
          status == 1 ? "justify-content-end" : "justify-content-start"
        } `}
      >
        {status == 1 &&
          breadcrumps.map((item, i) => (
            <div className="breadcrump d-flex" key={i}>
              <span className="mb-0 badge text-md fw-medium px-20 py-9 radius-4 text-secondary">
                {item.metric_name}
              </span>
              {i < breadcrumps.length - 1 && (
                <span className=" text-lg "> {">"} </span>
              )}
            </div>
          ))}

        {status == 0 && (
          <p className="mb-0 badge text-lg fw-medium px-20 py-9 radius-4 text-secondary">
            {metricname}
          </p>
        )}
      </div>
      <div className="level0Metrics row g-3">
        {childComparisonMetrics
          ?.filter(
            (filterItem) =>
              filterItem.value && Object.keys(filterItem.value).length > 0
          )
          ?.map((item, i) => (
            <div className="level0Metric col-12 col-md-6" key={i}>
              {renderChart(item.comparison_chart_type, item, i)}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ComparisonChildChartComponent;
